import { SCConfig } from '../../sc-config/constant/sc-config.constant';

export class ServiceModel {
    ServiceName: string;
    Unit: number;
    Quantities: number;
    UnitPrice: number;
    TotalPrice: number;
    Vat: number;
    UpdatedOfferNumber: string;
    Remarks: string;
    CaseTradeId: string;
    CaseTradeName: string;
    CaseComponentId: string;
    CaseComponentName: string;
    NewPrice: number;
    SavedCost: number;
    ServiceAdditionalData: any;
    ConstructionCompanyName: string;
    ConstructionCompanyEmail: string;
    ConstructionCompanyPhone: string;
    ServiceProviderInfo: any;
    constructor(service?, role?) {
        this.ServiceName = (service && service.ServiceList) || '';
        this.Unit = (service && service.Unit) || null;
        this.Quantities = (service && service.Quantity) || null;
        this.UnitPrice = (service && service.UnitPrice) || null;
        this.TotalPrice = (service && service.TotalPrice) || null;
        this.Vat = (service && service.VatSentence) || null;
        this.UpdatedOfferNumber = (service && service.UpdatedOfferNumber) || null;
        this.Remarks = (service && service.Remarks) || '';
        this.ConstructionCompanyName = (service && service.ConstructionCompanyName) || '';
        this.ConstructionCompanyEmail = (service && service.ConstructionCompanyEmail) || '';
        this.ConstructionCompanyPhone = (service && service.ConstructionCompanyPhone) || '';
        this.ServiceAdditionalData = {
            CaseTradeId: (service && service.ServiceAdditionalData && service.ServiceAdditionalData.CaseTradeId) || '',
            CaseTradeName:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.CaseTradeName) || '',
            CaseComponentId:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.CaseComponentId) || '',
            CaseComponentName:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.CaseComponentName) || '',
            NewPrice:
                role === SCConfig.CheckRole.ADMIN
                    ? (service && service.ServiceAdditionalData && service.ServiceAdditionalData.NewPrice) || 0
                    : (service && service.ServiceAdditionalData && service.ServiceAdditionalData.NewPrice) ||
                      (service && service.TotalPrice) ||
                      0,
            SavedCost: (service && service.ServiceAdditionalData && service.ServiceAdditionalData.SavedCost) || 0,
            Unit:
                role === SCConfig.CheckRole.ADMIN
                    ? (service && service.ServiceAdditionalData && service.ServiceAdditionalData.Unit) || null
                    : (service && service.ServiceAdditionalData && service.ServiceAdditionalData.Unit) ||
                      (service && service.Unit) ||
                      null,
            Quantity:
                role === SCConfig.CheckRole.ADMIN
                    ? (service && service.ServiceAdditionalData && service.ServiceAdditionalData.Quantity) || 0
                    : (service && service.ServiceAdditionalData && service.ServiceAdditionalData.Quantity) ||
                      (service && service.Quantity) ||
                      0,
            UnitPrice:
                role === SCConfig.CheckRole.ADMIN
                    ? (service && service.ServiceAdditionalData && service.ServiceAdditionalData.UnitPrice) || 0
                    : this.getUnitPrice(service),
            TotalPrice:
                role === SCConfig.CheckRole.ADMIN
                    ? (service && service.ServiceAdditionalData && service.ServiceAdditionalData.TotalPrice) || 0
                    : (service && service.ServiceAdditionalData && service.ServiceAdditionalData.TotalPrice) ||
                      (service && service.TotalPrice) ||
                      0,
            ConstructionCompanyName:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.ConstructionCompanyName) ||
                (service && service.ConstructionCompanyName) ||
                0,
            ConstructionCompanyEmail:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.ConstructionCompanyEmail) ||
                (service && service.ConstructionCompanyEmail) ||
                0,
            ConstructionCompanyPhone:
                (service && service.ServiceAdditionalData && service.ServiceAdditionalData.ConstructionCompanyPhone) ||
                (service && service.ConstructionCompanyPhone) ||
                0
        };
    }

    getUnitPrice(service) {
        if (service && service.ServiceAdditionalData && service.ServiceAdditionalData.UnitPrice > 0) {
            return service.ServiceAdditionalData.UnitPrice;
        } else {
            return (service && service.UnitPrice) || 0;
        }
    }
}
